export default __webpack_public_path__ + "static/media/face-2.cfe38984.svg";